import { useEffect, useState } from "react";

import ViewSectionName from "./view-section-name";
import ViewDividerSmall from "./view-divider-sm";
import WebbLoader from "./webb-loader";

import VaultDocsModule from "./vault-docs-module";

import { GetAuthUser } from "../services/user-accounts";
import { GetUserDocsList } from "../services/user-vault";

export default function VaultDocsListModule() {

  const asset = GetAuthUser();
  
  const [loading,setLoading]=useState(false);
  const [data,setData]=useState([]);

  useEffect( () => {
    if (asset){
      const fetchData = async() => {
        setLoading(true);
        setData( (await GetUserDocsList(JSON.stringify({
          body: {usid: asset.usid, form: asset.form},
          user: {usid: asset.usid, form: asset.form}
        }))).data)
        setLoading(false);
      }
      fetchData()
    } else {}
  },[asset.usid]);

  if (loading)
  return (<> <WebbLoader /> </>)

  return (
    <>

    <div className="">
      <ViewSectionName data={'My Academic Credentials'}/>
      <VaultDocsModule data={data && data.filter(item => item.sort==="acad")}/>

    </div>
    </>
  )
}